module.exports = __webpack_public_path__ + "static/media/zocalo14.aba0f1c7.jpg";